const handle = (id, checked, setChecked) => {
  const currentIndex = checked.indexOf(id);
  const newChecked = [...checked];

  if (currentIndex === -1) {
    newChecked.push(id);
  } else {
    newChecked.splice(currentIndex, 1);
  }

  setChecked(newChecked);
};

export default handle;
